// Function loadProfileListingItemBlock loads the profileProductBlock class by dynamically importing the js on demand if needed

export function loadProfileListingItemBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-profile-listing-item-block-chunk" */ '../widgets/profileListingItemBlock').then(wg => {

		const { ProfileListingItemBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ProfileListingItemBlock"]');

		if(!$wg) {
			// console.info('ProfileListingItemBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ProfileListingItemBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ProfileListingItemBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ProfileListingItemBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ProfileListingItemBlock widget');

}
